import { Row, Col, Card } from "antd";
import Data from "../../../CustomText/data";
import { parseUnixEpochToReadableTimestamp } from "../../../../helpers/genericHelper";

export default function ChargeAndDisputesDetails ({ charge, disputes }) {
  return <Card style={{marginTop: "1em"}}>
    <Row>
      <Col span="8">
        <Data title="Charge ID" value={charge?.id} />
        {
          charge?.id &&
            <strong><a
              href={"https://dashboard.stripe.com/payments/" + charge?.paymentIntent}
              title="Open in Stripe"
              target="_blank"
            >&nbsp;<small>open</small></a></strong>
        }
      </Col>
      <Col span="6">
        <Data title="Disputes" value={`${disputes?.length || 0} dispute(s)`} />
      </Col>

      <Col span="6">
        <Data title="Created" value={parseUnixEpochToReadableTimestamp(charge?.created)} />
      </Col>
      <Col span="4">
        <Data title="Amount Captured" value={`$${charge?.amountCaptured / 100}`} />
      </Col>
    </Row>
    {disputes &&  disputes.length > 0 &&
      <Card type="inner" size="small" style={{marginTop: "1em"}}>
        <h4>Disputes</h4>
        {disputes.map(dispute => (
          <Row key={dispute.id} style={{marginTop: "1em"}}>
            <Col span="5">
              <Data title="Dispute ID" value={dispute.id} />
            </Col>
            <Col span="3">
              <Data title="Amount" value={`$${dispute.amount / 100}`} />
            </Col>
            <Col span="4">
              <Data title="Status" value={dispute.status} />
            </Col>
            <Col span="4">
              <Data title="Reason" value={dispute.reason} />
            </Col>
            <Col>
              <Data title="Created" value={parseUnixEpochToReadableTimestamp(dispute.created)} />
            </Col>
          </Row>))}
      </Card>
    }
  </Card>
}